export default __webpack_public_path__ + "static/media/MarketArea.60a823d5.jpg";